var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "url(#pattern0_3_697)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3_697",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3_697",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3_697",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEmElEQVR4nO2cWchVVRSAj5lzQuZElGV/w0sKTmj1UihFURBEQUYlFBWSUQoiKYEPIhUp1EMRIiiGQRGRDQRBA1RWTkUIUkZUmkVl/ZnlUH6xuUv6sXvO2efs4Z5hfY8//91r7++eYZ219rlJoiiKoiiKoiiKoiiKoiiKonSD+BwDXgNuA0a5fCvABcDDwEfAQaAf+ABYBIyo1DceUfB24EFgouN8xwH3Au8DJzLifSf/NzipAjmTdeVzOeLOd5zjWJH2NvBPwTl8Blzrz1h1RB8D1gGzHOc1GrhdLjNmTFfeAmb4M1d8QUWPkCy+AKY6zGU4cBPwIvAn/jFrfQ6Y7NdiXNG/ApNKxB8CXAdslJtZDI4ATwBnhbEaVvSKAjFPA64EngF+oneYTGWpOZMKOpsMLAA2AF/bfuhvT5O+1CLWbGAtsI9q8Q1whzkAbMSe+uHYos9IGX8KsArYS/XZBVyTJ7bXooemjN94bEUf9xRvXOAvsrLEFn1xyvjf03Bii74hZfwtNBxb0T6eugzLU8afT8OJLfrdjJx5Bw0mtujjwPiUGH3Aj57imJvrl8CrwOPA3cDlwBipDvosKXgVfdRjzJUZcfoKHtmHgZ3AZuAR4BZTRwGG5aznVs9rqqToX9KO6gGXESPiFWC/xP4BeA94FlhsSprywDDIagHd48yLWDfpiWjD80kFAKbFSi1tJxTiNFuaVAA5M/YQmF6KPpF1vY6JKYVKHzEYthMxtdlQvOTaI0yZ85nAZcBdwGPmmpzz/6OAN0It0nbSfxGW34HVwHklhE4CrgYeAJ6WnuGBLjHMWTnfosFgmguNFX0Sk99+AqyRdtUc4EJJ+2bK35YDm4Bt8gUVHf+hnLUOknp4o0XH4sm0Av6ANS/z2ZRuq2jkrBiSs+4FvgpqbRZ9cnvB6Jy13+hj/baiQ7T1q4K5J0zIWf9Vrk+RKrrDV8BFObJnuhS9VPR/mJRweo7svrINZFvRpkrWBg6ZDneOi7Nlr14hVPT/MU/BN1tsqDTbgK1R0d0x+fMSi0f2d/As+g/ayaqsmrfsZrUqRqnofDZkPdjIZWSvL9HmJtFmtgAjM/xMyXNkJbrLwIOBF2gXH6fttBIn5q0Fv6Jl4GHAm7SL3cC5GTfHfu+iZfCRZq8G7WJnWpcdWB9E9IA7b6GcsgHcn+LizmCiJcAY2TfcFrZmdNXDiZYg4+Ua1gYOpTiYGFz0gEDBW/cVoN+rOId9Et/SwktHdIBLUjrRTWFRUhXkaelnmseutHdxeoZ0JX6jWZLPSaoIcEXNqn9HgHukKndQahgfys9OVOtIPhVgbo066f1JnQGuj735u9YZhQumRUT13ymsTkbhAp33qaO/Q1LbjMIF4L7Av2rTrIzCBWBJD2TWN6Nwgc6bVDGpd0bhAvBoRNH1zyhcAJ6KJLoZGUVZ6OyyT20DeaJZGUVZ6HTWNweU3LyMoix0XtZ5uaTMdmYUZQGGAq+XEN3ejCLyNoatvZ53LaH4NoZ2ZxQetjF8aiFZMwpPnfUdOZI1o/B0ZJ8OLJSMwvy+qWYUiqIoiqIoiqIoSQD+BWRUKbX+ob/xAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/Handshake.bc95da12aa30aa01daf8212cd74ef049.svg";
export { ForwardRef as ReactComponent };